import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CompanyService } from '@company/feature';
import { AddCompanyButtonComponent } from '@sdvor/company/ui/v2';
import {
  DropdownComponent,
  DropdownMenuComponent,
  DropdownMenuItemComponent,
  DropdownTogglerComponent,
} from '@sdvor/shared/ui/v2';
import { CurrentProfileService } from '@user/feature';

@Component({
  selector: 'sd-switch-profile',
  standalone: true,
  imports: [
    DropdownComponent,
    DropdownTogglerComponent,
    DropdownMenuComponent,
    DropdownMenuItemComponent,
    AddCompanyButtonComponent,
  ],
  templateUrl: './switch-profile.component.html',
  styleUrls: ['./switch-profile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwitchProfileComponent {
  private readonly currentProfileService = inject(CurrentProfileService);
  private readonly companyService = inject(CompanyService);

  readonly currentProfile = toSignal(this.currentProfileService.get());

  selectCompany(companyUid: string): void {
    this.companyService.selectCompany(companyUid);
  }

  resetCompany(): void {
    this.companyService.resetSelectedCompany();
  }
}
